var map = {
	"./bg.jpg": "fb40",
	"./bg_Strong.png": "7f25",
	"./bg_black.png": "ff08",
	"./bg_black2.png": "296e",
	"./bg_black_.png": "b405",
	"./bg_black_border.png": "c448",
	"./bg_blue.png": "e796",
	"./bg_green.png": "5b7d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9f71";